import React, { useState, useEffect } from 'react'
import * as firebase from '../helpers/firebase'
import './NoteEditBox.scss'
import ColorPicker from './ColorPicker.js'
import menuIcon from './hotDogMenu.png'

// Accepts note input and saves it.
// Saves to Localstorage onChange.
// Saves permanently to DB onBlur.
// Only note.data gets written to the db, the rest of the fields are metadata.
// Even if the user is offline, notes get "written" to Firestore when the saveNote function runs.
// Once the user gets back online, Firestore will save it to the database. Even unsaved notes show up in the notes list immediately.
const NoteEditBox = (props) => {
    console.log('Note: ')
    const [currentNote, setCurrentNote] = useState(null)
    const [colorPickerDisplay,setColorPickerDisplay] = useState(false)
    const [noteColor,setNoteColor] = useState(props.note.data.color)
    const [isMenuShown,setMenuShown] = useState(false)
    
    const user = props.user

    useEffect(() => {
        setCurrentNote(props.note)
    }, [props])

    function handleTitleOnChange(e) {
        const updatedNote = { ...currentNote }
        updatedNote.data.title = e.target.value
        handleNoteChange(updatedNote)
    }

    function handleNoteTextOnChange(e) {
        const updatedNote = { ...currentNote }
        updatedNote.data.text = e.target.value
        handleNoteChange(updatedNote)
    }
    function handleColorChange(color) {
        setNoteColor(color)
        console.log("Color Change Current Note Id: " + currentNote.id)
        const updatedNote = { ...currentNote }
        updatedNote.data.color = color
        handleNoteChange(updatedNote)
        console.log("Color Change Updated Note Id: " + updatedNote.id)
    }
    function handleNoteChange(updatedNote) {
        if (!updatedNote.id) {
            updatedNote.id = firebase.generateDocumentId()
        }
        setCurrentNote(updatedNote)
    }


    function toggleColorPicker(){
        setColorPickerDisplay(!colorPickerDisplay)
    }


/* Check if either the Note or Title Edit box is currently focused 
If neither is currently focused, close editor and Save the note
*/
    async function handleOnBlur(e) {
        e.stopPropagation()
        console.log('handleOnBlur')
        
        if (currentNote.data.text.trim().length > 0) {
            const noteToSave = { ...currentNote }
            
            saveNote(noteToSave)
                .then()
                .catch(e => {
                    console.log('Failed to save', e)
                })
        }
        props.toggleDisplay() 
    }
// Save and Delete
    function saveNote(note) {
        const db = firebase.getDb()
        console.log(note.id)
        console.log("Note updated")
        props.toggleDisplay()

        return db.collection(`/users/${user.uid}/notes`)
                .doc(note.id)
                .set({ ...note.data, createdDatetime: firebase.clientTimestamp() }, { merge: true })
    }

    async function deleteNote(e) {
        e.stopPropagation()

        const db = firebase.getDb()
        props.toggleDisplay()

        return db.collection(`/users/${user.uid}/notes`)
                .doc(currentNote.id)
                .delete()
                .then(function() {
                    console.log("note deleted successfully")
                }).catch(function(error){
                    console.log(error)
                })
    }

    return (
        <div>
            { currentNote && 
                <div className='note-edit-box'>
                    <div className='scrim' onClick={handleOnBlur}></div> {/* dim the background when editor is shown */}
                    <div id="note-edit-container">
                            <div className="note-edit-textarea-wrapper">
                                    <div className='note-title-container'>
                                        <input className="titlearea"
                                                onClick={e => e.stopPropagation()}
                                                placeholder='Title this note...'
                                                onChange={handleTitleOnChange}
                                                value={currentNote.data.title}
                                                aria-multiline={true}
                                                aria-label='Note input'
                                                style={{backgroundColor:noteColor}}>
                                        </input>
                                        <div className='note-edit-menu'>
                                            {isMenuShown
                                                ?<div className='h-100'>
                                                    <div className='note-edit-menu-icon-container'>
                                                        <img onClick={()=>{setMenuShown(!isMenuShown)}} src={menuIcon} style={{transform:isMenuShown?'scale(1.3)':'scale(1)'}} className='note-edit-menu-icon' alt=''></img>
                                                    </div>
                                                    <div className='note-edit-options'>
                                                        <div className='note-edit-menu-options-container'>
                                                            <div className='d-flex justify-content-start' id='btn-holder-save'>
                                                                <button className="btn" id="btn-save" onClick={handleOnBlur} >Save</button>
                                                            </div>
                                                            {/* Color Picker */}
                                                            {colorPickerDisplay 
                                                            ?<div>
                                                                <ColorPicker 
                                                                note={currentNote} 
                                                                noteColor={noteColor} 
                                                                handleColorChange={handleColorChange} 
                                                                toggleColorPicker={toggleColorPicker}>
                                                                </ColorPicker>
                                                                <div 
                                                                    className='color-picker-button' 
                                                                    noteColor={noteColor} 
                                                                    style={{visibility:"hidden"}} 
                                                                    onClick={toggleColorPicker}>
                                                                </div>
                                                            </div>
                                                            :<div 
                                                                className='color-picker-button' 
                                                                noteColor={noteColor} 
                                                                // style={{backgroundColor:noteColor}} 
                                                                onClick={toggleColorPicker}>
                                                            </div>
                                                            }
                                                            <div className='d-flex justify-content-start' id='btn-holder-delete'>
                                                                <button className="btn" id="btn-delete" onClick={deleteNote} >Delete</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                :<div className='note-edit-menu-icon-container'>
                                                    <img onClick={()=>{setMenuShown(!isMenuShown)}} src={menuIcon} className='note-edit-menu-icon' alt=''></img>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <textarea className="textarea"
                                            onClick={e => e.stopPropagation()}
                                            placeholder='Type something...'
                                            onChange={handleNoteTextOnChange}
                                            value={currentNote.data.text}
                                            aria-multiline={true}
                                            aria-label='Note input'
                                            style={{backgroundColor:noteColor}}
                                    ></textarea>
                                                                                                
                            </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default NoteEditBox